import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CoreFacade } from '@core/core.module';

@Component({
    selector: 'app-context',
    templateUrl: './context.component.html',
    styleUrls: ['./context.component.scss'],
    standalone: false
})
export class ContextComponent implements OnInit {
    constructor(private coreFacade: CoreFacade, private activatedRoute: ActivatedRoute) { }

    ngOnInit(): void {
        const clubId = this.activatedRoute.snapshot.paramMap.get('clubId');
        this.coreFacade.setUpClubContext(clubId);
    }
}
